import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mapView", "resultsGrid", "mapViewBtn", "listViewBtn"]

  connect() {
    this.showList() 
  }

  showMap() {
    this.mapViewTarget.classList.remove("hidden")
    this.resultsGridTarget.classList.add("hidden")
    this.setActive(this.mapViewBtnTarget)
    this.setInactive(this.listViewBtnTarget)
  }

  showList() {
    // 1. Swap Views
    this.mapViewTarget.classList.add("hidden")
    this.resultsGridTarget.classList.remove("hidden")

    this.setActive(this.listViewBtnTarget)
    this.setInactive(this.mapViewBtnTarget)
  }

  setActive(element) {
    element.classList.add("bg-white", "dark:bg-slate-700", "shadow-sm", "text-indigo-600", "dark:text-indigo-400")
    element.classList.remove("text-slate-500", "dark:text-slate-400", "hover:text-slate-900", "dark:hover:text-white")
  }

  setInactive(element) {
    element.classList.remove("bg-white", "dark:bg-slate-700", "shadow-sm", "text-indigo-600", "dark:text-indigo-400")
    element.classList.add("text-slate-500", "dark:text-slate-400", "hover:text-slate-900", "dark:hover:text-white")
  }
}